module.exports = __webpack_public_path__ + "img/a1.88f09a5c.jpg";